export default "__VITE_ASSET__DnE5jw9I__"